function o() {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}
export {
  o as randomColour
};
//# sourceMappingURL=index.js.map
